import React from 'react';
import { Button, Paper, CircularProgress, Alert } from '@mui/material';

interface FetchCompaniesSectionProps {
  loading: boolean;
  error: string | null;
  onFetchCompanies: () => void;
}

const FetchCompaniesSection: React.FC<FetchCompaniesSectionProps> = ({
  loading,
  error,
  onFetchCompanies,
}) => {
  return (
    <>
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
      <Alert severity="info" sx={{ mt: 2 }}>
        Please make sure to activate the company in Tally to fetch its GST
        number.
      </Alert>
      <Paper sx={{ p: 2, my: 2 }}>
        <Button
          variant="contained"
          onClick={onFetchCompanies}
          disabled={loading}>
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            'Fetch Companies from Tally'
          )}
        </Button>
      </Paper>
    </>
  );
};

export default FetchCompaniesSection;
